import { IonText, IonItem, IonLabel } from '@ionic/react';
import { Field as RCField } from 'rc-field-form';
import { Rule, StoreValue } from 'rc-field-form/es/interface';
import React from 'react';
import styled from 'styled-components';

import { FieldItemProps, LabelPosition } from './types';

type Props = {
  name: string;
  rules: Rule[];
  label?: string;
  labelPosition?: LabelPosition;
  showItemBorder?: boolean;
  children: React.ReactElement<FieldItemProps>;
  normalize?: (value: StoreValue) => void;
  getValueProps?: (value: StoreValue) => Record<string, unknown>;
};

type ErrorProps = {
  invalid?: boolean;
  showItemBorder?: boolean;
};

const Item = styled(IonItem)<ErrorProps>`
  width: 100%;
  padding: 0 16px;
  --padding-start: 0px;
  --padding-end: 0px;
  --inner-padding-end: 0px;
  --border-style: ${({ showItemBorder }) =>
    // skipcq: JS-W1043
    !showItemBorder && 'none'};
  --border-color: ${({ invalid }) => (invalid ? 'var(--ion-color-danger)' : '')};
`;

const Label = styled(IonLabel)`
  &.label-stacked.sc-ion-label-md-h {
    transform: none;
  }
  ${({ position }) => (position === LabelPosition.STACKED ? 'margin-top: 0px;' : null)}
  padding-top: ${({ position }) => (position === LabelPosition.STACKED ? '24px' : '0px')};
`;

const Text = styled.div`
  padding: 8px 16px;
`;

const Field = ({
  name,
  rules,
  label,
  labelPosition = LabelPosition.FLOATING,
  showItemBorder = true,
  children,
  normalize,
  getValueProps,
}: Props) => (
  <RCField name={name} rules={rules} normalize={normalize} getValueProps={getValueProps}>
    {({ onChange, value }, { errors }) => {
      const hasError = errors.length > 0;

      return (
        <>
          <Item invalid={hasError} showItemBorder={showItemBorder}>
            {label && (
              <Label position={labelPosition} color={hasError ? 'danger' : undefined}>
                {label}
              </Label>
            )}
            {React.cloneElement(children, { hasError, onIonChange: onChange, value, name })}
          </Item>
          {hasError && (
            <IonText color="danger">
              <Text>{errors[0]}</Text>
            </IonText>
          )}
        </>
      );
    }}
  </RCField>
);

export default Field;
